<template>
  <div>
    <vx-card class="mb-1">
        <vs-row vs-type="flex" vs-justify="space-between" >
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="3">         
              <label class="vs-input--label mr-2">Favorecido</label>              
              <vs-input class="mb-4 w-full" v-model="filtro.favorecido.nome" @keyup.enter="fetchLista(filtro)" />
          </vs-col>                    
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="5">       
            <label class="vs-input--label mr-2">Período</label>              
            <div class="flex items-center">
              <flat-pickr v-model="filtro.dataInicio" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker" />
              <label class="vs-input--label mr-2">à</label>
              <flat-pickr v-model="filtro.dataFim" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker"/>
            </div>           
          </vs-col>             
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="3">
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" icon="icon-search" @click="fetchLista(filtro)"></vs-button>
            <vs-button class="mr-2" color="dark" type="border" icon-pack="feather" icon="icon-file" @click="limparFiltros"></vs-button>  
            <vs-button class="mr-2" color="warning" type="filled" icon-pack="feather" icon="icon-plus" @click="routeNovoRegistro"></vs-button>          
            <vs-button color="rgb(11, 189, 135)" type="filled" icon-pack="feather" icon="icon-save" @click="exportarParaCSV"></vs-button>          
          </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="space-between" >
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="3"> 
          </vs-col>
          <vs-col vs-type="flex" vs-w="5" vs-justify="center">
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" size="small" icon="icon-arrow-left" @click="setMes(false)"> </vs-button>
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" size="small" icon="icon-calendar" @click="setMesAtual"></vs-button>
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" size="small" icon="icon-arrow-right" @click="setMes(true)"> </vs-button>
          </vs-col>
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="3"> 
          </vs-col>
      </vs-row>

    </vx-card>
     
    <h6 class="ml-2 mt-2 mb-2 text-danger"> {{dadosDaGrid.length }} registros </h6>
    <vx-card class="mb-1">
      <ag-grid-vue
        ref="agGridTable"           
        :gridOptions="configuracaoGrid.gridOptions"
        class="ag-theme-material ag-grid-table ag-grid-altura"
        :columnDefs="configuracaoGrid.columnDefs"
        :defaultColDef="configuracaoGrid.defaultColDef"
        :rowData="dadosDaGrid"
        :rowHeight="25"
        :headerHeight="20"        
        rowSelection="single"
        colResizeDefault="shift"
        @row-selected="onRowSelectedRegistro"    
        :animateRows="true"
        :floatingFilter="false"
        :pagination="false"
        :paginationAutoPageSize="false"
        :suppressPaginationPanel="true"
        >
      </ag-grid-vue>      
    </vx-card>
    
  </div>

</template>

<script>
import generico from '@/generico.js'
import axios from "@/axios.js"
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'

const URL_SERVLET = "/ItemContaFuturo/ListarItemContaFuturo";
const NAME_ROUTE_EDIT = "financeiro-item-conta-futuro-editar";


export default {
  components: {
    AgGridVue,
    flatPickr
  },
  data() {
    return {
      filtro : {favorecido: {nome: null }, dataInicio:  null,dataFim : null},
      configuracaoGrid: { 
          gridApi: null, gridOptions: {}, 
          defaultColDef: { sortable: true, resizable: true, suppressMenu: true  },
          columnDefs: [        
            { headerName: 'N', field: 'id', width: 20              
            },                                   
            { headerName: 'CLIENTE', field: 'favorecido.nome' },                      
            { headerName: 'DESCRIÇÃO', field: 'descricaoItem'},
            { headerName: 'QTD', field: 'qtd', width: 40,
               cellRenderer: function(params) { return generico.formatarNumero(params.data.qtd) } 
            },  
            { headerName: 'PREÇO UNI.', field: 'precoUnitario', width: 40, 
               cellRenderer: function(params) { return generico.formatarMoedaReal(params.data.precoUnitario) }
            },                                                                                            
            { headerName: 'FATURA', field: 'dataInclusaoFaturaFormatado', width: 40},                                                                                            
            { headerName: 'EXECUTADO', field: 'dataHoraIncluidoFormatado', width: 40},                                                                                            
          ]
      },
      dadosDaGrid: [],
      totalRegistros: 0,
      configDatePicker: {          
          altInput: true,
          altFormat: "d-m-Y",
          dateFormat: "Y-m-d", 
          altInputClass: "vs-inputx vs-input--input normal hasValue text-center",
          locale: PortugueseLocale
      },  
      numeroMesAtual: 0 
    }
  },  
  created() {
      
  },
  methods: {
    setMes(incrementar){
      
      if (incrementar) {
        this.numeroMesAtual = this.numeroMesAtual + 1;
      } else {
        this.numeroMesAtual = this.numeroMesAtual - 1;
      }

      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth() + this.numeroMesAtual, 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1 + this.numeroMesAtual, 0);


      this.filtro.dataInicio = firstDay.toISOString().split('T')[0];
      this.filtro.dataFim = lastDay.toISOString().split('T')[0];
    },
    setMesAtual(){
      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.filtro.dataInicio = firstDay.toISOString().split('T')[0];
      this.filtro.dataFim = lastDay.toISOString().split('T')[0];
      this.numeroMesAtual = 0;
    },
    limparFiltros() {
      this.filtro = {favorecido: {nome: null }, dataInicio:  null,dataFim : null};
    },
    fetchLista() {     
      this.$vs.loading() 
      const params = new URLSearchParams();
      params.append('pagina', -1);
      
      if (this.filtro.favorecido.nome) {
        params.append('favorecido.nome', this.filtro.favorecido.nome);
      }

      if(this.filtro.dataInicio != null){
        params.append("vencimentoInicio", this.filtro.dataInicio);
      }
      
      if(this.filtro.dataFim != null){
        params.append("vencimentoFim", this.filtro.dataFim);
      }

      axios.post(URL_SERVLET, params, {   
              headers: {'Accept': 'application/json' },           
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          this.$vs.loading.close();
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/' });
          } else {
            this.totalRegistros = response.data.Resultado.quantidade;              
            this.dadosDaGrid = response.data.Resultado.lista;                                          
          }
      })
      .catch((error) => { 
          this.$vs.loading.close();
          /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - fetchLista - " + error); 
      })    
                        
    },
    routeNovoRegistro() {
      let self_ = this;

      self_.$router.push({
            name: NAME_ROUTE_EDIT                     
      })
    },
    onRowSelectedRegistro(evento) {
      let self_ = this;
      let registro = evento.node.data;
      
      self_.$router.push({
            name: NAME_ROUTE_EDIT,
            params: {
              registroOriginal: registro
            }
      })

    },
    exportarParaCSV() {
      var params = {columnSeparator: ';', fileName: 'ItemContaFuturo.csv'};
      this.configuracaoGrid.gridApi.exportDataAsCsv(params);
    }
    
  },
  mounted() {
    this.configuracaoGrid.gridApi = this.configuracaoGrid.gridOptions.api;
    this.configuracaoGrid.gridApi.sizeColumnsToFit();   
    
    if (this.$store.getters.filtroItemContaFuturo) {
        this.filtro = JSON.parse(JSON.stringify(this.$store.getters.filtroItemContaFuturo));
    } else {
      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.filtro.dataInicio = firstDay.toISOString().split('T')[0];
      this.filtro.dataFim = lastDay.toISOString().split('T')[0];
    }   

    this.fetchLista(this.filtro);
    
  },
  beforeDestroy() {    
    this.$store.dispatch('setarFiltro', {nomeTela: 'itemContaFuturo' , filtro: this.filtro});
  }
}

</script>
<style lang="scss" scoped>
  .ag-grid-altura{
    height: calc(100vh - 310px);
  }
</style>
